import { AI_TOOL_TYPES } from './constants'

function toFormString(value) {
  return value != null && value !== '' ? String(value) : ''
}

export function mapPendingPaymentToBudgetBreakdownForm(pending) {
  const formData = pending.formData || {}

  return {
    projTitle: formData.projTitle || '',
    email: pending.email || '',
    uname: pending.fullName || formData.uname || '',
    format: formData.format || '',
    genre: formData.genre || '',
    market: formData.market || '',
    totalBudget: toFormString(formData.totalBudget),
    shootDays: toFormString(formData.shootDays),
    runtime: formData.runtime || '',
    castCount: toFormString(formData.castCount),
    locations: toFormString(formData.locations),
    nightShoots: toFormString(formData.nightShoots),
    vfxShots: toFormString(formData.vfxShots),
    castLevel: formData.castLevel || 'emerging',
    crewLevel: formData.crewLevel || 'indie',
    locationType: formData.locationType || 'practical',
    postLevel: formData.postLevel || 'basic',
    stunts: formData.stunts || 'none',
    period: formData.period || 'contemporary',
    music: formData.music || 'minimal',
    distrib: formData.distrib || 'festival',
    notes: formData.notes || '',
  }
}

export function mapPendingPaymentToProductionAnalyzerForm(pending) {
  const formData = pending.formData || {}

  return {
    formValues: {
      projectTitle: formData.projectTitle || '',
      email: pending.email || '',
      uname: pending.fullName || formData.uname || '',
      projectType: formData.projectType || '',
      currency: formData.currency || '',
      country: formData.country || '',
      locations: toFormString(formData.locations),
      shootDays: toFormString(formData.shootDays),
      budget: toFormString(formData.budget),
      actors: toFormString(formData.actors),
      productionMode: formData.productionMode || 'controlled',
      crowd: formData.crowd || 'no',
      night: formData.night || 'low',
      scenes: toFormString(formData.scenes),
      locationType: formData.locationType || 'mixed',
      crew: formData.crew || 'medium',
      post: formData.post || 'standard',
      musicBudget: toFormString(formData.musicBudget),
      postBudget: toFormString(formData.postBudget),
    },
    mode: formData.mode === 'advanced' ? 'advanced' : 'quick',
  }
}

export function mapPendingPaymentToOpportunityEngineForm(pending) {
  const formData = pending.formData || {}

  return {
    email: pending.email || '',
    uname: pending.fullName || formData.uname || '',
    selCrafts: formData.crafts || [],
    selCT: formData.contentTypes || [],
    country: formData.country || 'any',
    state: formData.state || 'any',
    city: formData.city || 'any',
    lang: formData.language || 'any',
    recency: formData.recency || 'any',
    gender: formData.gender || 'any',
    age: formData.age || '',
  }
}

const FORM_RESTORE_MAPPERS = {
  [AI_TOOL_TYPES.BUDGET_BREAKDOWN]: mapPendingPaymentToBudgetBreakdownForm,
  [AI_TOOL_TYPES.PRODUCTION_ANALYZER]: mapPendingPaymentToProductionAnalyzerForm,
  [AI_TOOL_TYPES.OPPORTUNITY_ENGINE]: mapPendingPaymentToOpportunityEngineForm,
}

export function mapPendingPaymentToFormValues(toolType, pending) {
  if (!pending) return null

  if (pending.rawFormValues) {
    if (toolType === AI_TOOL_TYPES.PRODUCTION_ANALYZER) {
      return {
        formValues: pending.rawFormValues,
        mode: pending.rawMode === 'advanced' ? 'advanced' : 'quick',
      }
    }

    return pending.rawFormValues
  }

  const mapper = FORM_RESTORE_MAPPERS[toolType]
  if (!mapper) return null
  return mapper(pending)
}
